export default "__VITE_ASSET__Uv_Wpr2a__"